import { Search } from 'react-bootstrap-icons'
import { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { TextInput } from '../Misc/FormInput';
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';
import './productTableStyle.css'

const ProductSearch = () => {
    const { instance } = useMsal();

    const normalizeResults = (data) => {
        if (Array.isArray(data)) {
            return data;
        }

        if (Array.isArray(data?.products)) {
            return data.products;
        }

        if (Array.isArray(data?.results)) {
            return data.results;
        }

        return [];
    };

    const [brands, setBrands] = useState([]);
    useEffect(() => {
        authFetch(instance, '/api/fetch_brands')
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setBrands(data);
            }).catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
            });
    }, [instance]);

    const [brand, setBrand] = useState('');

    const navigate = useNavigate()

    const [useExact, setUseExact] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);

    const [filterTerm, setFiterTerm] = useState('');

    const filteredResults = searchResults.filter((product) => {
        if (filterTerm === '') {
            return true;
        }

        const normalizedFilter = filterTerm.toLowerCase();
        const fields = [product?.name, product?.sku, product?.manufacturer_num, product?.hint]
            .map((value) => (value ?? '').toString().toLowerCase());

        return fields.some((value) => value.includes(normalizedFilter));
    });

    function searchProducts(searchTerm) {
        //console.log(searchTerm);
        setShowLoading(true);
        setHasSearched(true);
        authFetch(instance, '/api/search_products', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"searchTerm": searchTerm, "exact": useExact}),
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            //console.log(data);
            setSearchResults(normalizeResults(data));
            setShowLoading(false);
        }).catch(function(error) {
            setShowLoading(false);
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function searchProductsByBrand(brand) {
        //console.log(searchTerm);
        setShowLoading(true);
        setHasSearched(true);
        authFetch(instance, '/api/search_products', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"searchTerm": '', "exact": useExact, "brand": brand}),
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            //console.log(data);
            setSearchResults(normalizeResults(data));
            setShowLoading(false);
        }).catch(function(error) {
            setShowLoading(false);
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    function searchProductsByBoth(brand, searchTerm) {
        //console.log(searchTerm);
        setShowLoading(true);
        setHasSearched(true);
        authFetch(instance, '/api/search_products', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify({"searchTerm": searchTerm, "exact": useExact, "brand": brand}),
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            //console.log(data);
            setSearchResults(normalizeResults(data));
            setShowLoading(false);
        }).catch(function(error) {
            setShowLoading(false);
            alert('There was an error connecting to the database, please refresh the page.');
        });
    }

    return (
        <Container>
            <Row>
                <Col xs={4} className="text-start">
                    <h2>Products</h2>
                </Col>
                <Col xs={2} className="text-end align-self-center offset-6 d-grid">
                        {/*<button
                            style={{backgroundColor: "#a73c21",
                                borderRadius: "0px",
                                borderColor: "#a73c21",
                                color: '#ffffff'}}
                            onClick={() =>navigate('/edit_product', {state: {}})}
    >Create New Product</button>*/}
                <Button
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", borderRadius: "0px",
                    borderColor: "#a73c21"}}
                    onClick={() =>navigate('/edit_product', {state: {}})}
                >Create New Product</Button>
                </Col>
            </Row>
            <hr />
            <div>
                <Row className='d-flex align-items-center'>
                    <Col xs={5} >
                        <InputGroup>
                            <Form.Control type="text"
                                placeholder="Search for SKU, Manufacturer Number, Name..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" ? searchProducts(searchTerm) : {}}
                            />
                            <Button
                                style={{backgroundColor: "#a73c21",
                                    borderRadius: "0px",
                                    borderColor: "#a73c21"}}
                                onClick={() => {searchProducts(searchTerm)}}>
                                <Search/>
                            </Button>
                        </InputGroup>
                        
                    </Col>
                    <Col xs={1}>
                        <Form.Label className='align-bottom' style={{margin: "auto"}}>Brand:</Form.Label>
                    </Col>
                    <Col xs={4}>
                        <InputGroup className='align-middle'>
                            
                            <Form.Select value={brand} onChange={(e) => setBrand(e.target.value)}>
                                <option value={0} key={''}></option>
                                {brands.map((b, x) =>
                                    <option value={b.id} key={x}>{b.name}</option>
                                )}
                            </Form.Select>
                            <Button
                                style={{backgroundColor: "#a73c21",
                                        borderRadius: "0px",
                                        borderColor: "#a73c21"}}
                                    onClick={() => {searchProductsByBrand(brand)}}>
                                    <Search/>
                            </Button>
                        </InputGroup>
                    </Col>
                    <Col xs={2} className='text-start'>
                        <Form.Group>
                        <Form.Label>Search by Both: </Form.Label>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            style={{backgroundColor: "#a73c21",
                                    borderRadius: "0px",
                                    borderColor: "#a73c21"}}
                                onClick={() => {searchProductsByBoth(brand, searchTerm)}}>
                                <Search/>
                        </Button>
                        </Form.Group>
                    </Col>
                    {/*<BrandSelectInput
                        inputName="brand_id" inputLabel="Brand:" inputValue={brand} changeFunc={(e) => setBrand(e.target.value)} selectOptions={brands}/>
</Col>*/}
                    {/*<Col xs={5}>
                        <button
                            style={{backgroundColor: "#a73c21",
                                borderRadius: "0px",
                                borderColor: "#a73c21",
                                color: '#ffffff'}}
                            onClick={() =>navigate('/edit_product', {state: {}})}
                        >Create New Product</button>
    </Col>*/}
            </Row>
            <Row>
                <Col xs={2}>
                <InputGroup>
                    <Form.Check value={useExact} onChange={() => {setUseExact(!useExact);console.log(useExact)}}></Form.Check>
                    &nbsp;&nbsp;
                    <Form.Label name="exactLabel">Exact match</Form.Label>
                </InputGroup>
                </Col>
                
                <Col className='text-start' style={{display: (showLoading ? "block" : "none")}}>
                    <p>Searching for products...</p>
                </Col>
            </Row>
            </div>
            <Row style={{display: (hasSearched ? "block" : "none")}}>
                <Col xs={6} className="text-start">
                <TextInput placeholder="Start typing to filter products..." inputName="searchTerm" inputLabel="Filter:" inputValue={filterTerm} changeFunc={(event) => setFiterTerm(event.target.value)}/>
                </Col>
            </Row>
            <div style={{display: (hasSearched ? "block" : "none")}}>
                <DataTable
                    columns={[
                        {
                            name: 'Name',
                            //selector: row => row.name,
                            cell: row => 
                                <div className='cell-text-wrap'>{row.name}</div>,
                            sortable: true
                        },
                        {
                            name: 'SKU',
                            //selector: row => row.sku,
                            cell: row => 
                                <div className='cell-text-wrap'>{row.sku}</div>,
                            sortable: true
                        },
                        {
                            name: 'MFR',
                            //selector: row => row.manufacturer_num,
                            cell: row => 
                                <div className='cell-text-wrap'>{row.manufacturer_num}</div>,
                            sortable: true
                        },
                        {
                            name: 'Hint',
                            //selector: row => row.hint,
                            cell: row => 
                                <div className='cell-text-wrap'>{row.hint}</div>,
                            sortable: true
                        },
                        {
                            name: "Modified",
                            selector: row => {
                                const modifiedValue = row?.modifiedDate || row?.modified_date || '';
                                return modifiedValue ? modifiedValue.toString().split('.')[0] : '';
                            },
                            sortable: true
                        }
                    ]}
                    defaultSortFieldId={4}
                    defaultSortAsc={0}
                    data={filteredResults}
                    noDataComponent={hasSearched && !showLoading ? 'No matching products found.' : ''}
                    onRowClicked={(product) => {navigate('/edit_product', {state: product})}}
                    pagination
                    highlightOnHover
                    striped
                />
            </div>
        </Container>
    );
}
 
export default ProductSearch;